import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import militaryAge18Png from '@/assets/landing-activity-male/military-18.png'
import militaryAge30Png from '@/assets/landing-activity-male/military-30.png'
import militaryAge40Png from '@/assets/landing-activity-male/military-40.png'
import militaryAge50Png from '@/assets/landing-activity-male/military-50.png'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Your sexual comeback starts here',
			uppercase: true,
			size: 'large',
			customStyles: {
				marginLeft: '1rem',
				marginRight: '1rem',
			},
		}),

		LandingSubtitle: (): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: 'Select your age',
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'military',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-29',
					label: $t('female_activity.pages.landing.step_1.options.18_29'),
					img: militaryAge18Png,
				},
				{
					value: 30,
					analyticValue: '30-39',
					label: $t('female_activity.pages.landing.step_1.options.30_39'),
					img: militaryAge30Png,
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_activity.pages.landing.step_1.options.40_49'),
					img: militaryAge40Png,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_activity.pages.landing.step_1.options.50'),
					img: militaryAge50Png,
				},
			],
		}),
	},
}

export default schema
